/* react-router-dom */
import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from '../components/errorpage/ErrorPage';
import lazyRetry from '../helpers/utils/lazyRetry';

// Componentes protegidos
import ProtectedRoute from './ProtectedRoute';
import AppLayout from './AppLayout';

// Componentes (lazy)
const Home = lazy(() => lazyRetry(() => import('../components/home/Home')));
////// login
const Login = lazy(() => lazyRetry(() => import('../components/login/Login')));
const Logout = lazy(() => lazyRetry(() => import('../components/login/Logout')));

////// users
const Users = lazy(() => lazyRetry(() => import('../components/users/Users')));

////// vendors
const Vendors = lazy(() => lazyRetry(() => import('../components/vendors/Vendors')));

////// stock
const Stock = lazy(() => lazyRetry(() => import('../components/stock/Stock')));
const StockSettings = lazy(() => lazyRetry(() => import('../components/stock/StockSettings')));
const NewProduct = lazy(() => lazyRetry(() => import('../components/stock/NewProduct')));
const EditProduct = lazy(() => lazyRetry(() => import('../components/stock/EditProduct')));
const NewItem = lazy(() => lazyRetry(() => import('../components/stock/NewItem')));
const ListItems = lazy(() => lazyRetry(() => import('../components/stock/ListItems')));
const EditItem = lazy(() => lazyRetry(() => import('../components/stock/EditItem')));

const BatchItems = lazy(() => lazyRetry(() => import('../components/stock/BatchItems')));
const MakeUpStock = lazy(() => lazyRetry(() => import('../components/customers/MakeUpStock')));
const ReportsLanding = lazy(() => lazyRetry(() => import('../components/reports/ReportsLanding')));
const AccountantReport = lazy(() => lazyRetry(() => import('../components/reports/AccountantReport')));

const NewPurchaseOrder = lazy(() => lazyRetry(() => import('../components/vouchers/purchaseOrders/NewPurchaseOrder')));
const ListPurchaseOrders = lazy(() => lazyRetry(() => import('../components/vouchers/purchaseOrders/ListPurchaseOrders')));
const EditPurchaseOrder = lazy(() => lazyRetry(() => import('../components/vouchers/purchaseOrders/EditPurchaseOrder')));

const router = createBrowserRouter([
  {
    path: '/login/:lang?',
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/logout',
    element: <Logout />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: <Home />,
          },
          {
            path: 'users',
            element: <Users />,
          },
          {
            path: 'vendors',
            element: <Vendors />,
          },
          {
            path: 'stock',
            element: <Stock />,
          },
          {
            path: 'stock/settings',
            element: <StockSettings />,
          },
          {
            path: 'stock/new',
            element: <NewProduct />,
          },
          {
            path: 'stock/edit/:id',
            element: <EditProduct />,
          },
          {
            path: 'stock/add/:id',
            element: <NewItem />,
          },
          {
            path: 'stock/items/batch/:id',
            element: <BatchItems />,
          },
          {
            path: 'stock/items/:id',
            element: <ListItems />,
          },
          {
            path: 'stock/items/edit/:id',
            element: <EditItem />,
          },
          {
            path: 'reports',
            element: <ReportsLanding />,
          },
          {
            path: 'reports/inventory',
            element: <MakeUpStock />,
          },
          {
            path: 'reports/accountant',
            element: <AccountantReport />,
          },
          {
            path: 'purchases',
            element: <ListPurchaseOrders />,
          },
          {
            path: 'purchases/new',
            element: <NewPurchaseOrder />,
          },
          {
            path: 'purchases/edit/:id',
            element: <EditPurchaseOrder />,
          },
          {
            path: '*',
            element: <Home />,
          },
        ],
      },
    ],
  },
]);

export default router;
